// extracted by mini-css-extract-plugin
module.exports = {"action":"user_panel_action__2xwIm","avatar":"user_panel_avatar__1Rxwh"};